// Live auto-grade tuning knobs — pure module (NO firebase import) so it's safe to
// pull into grade.js (which is also imported by node scripts). The Firestore sync
// lives in src/data/gradingConfigSync.js and just calls setGradingConfig().
//
// KEEP DEFAULTS IN SYNC with backend/shared/gradingConfig.js.

export const GRADING_DEFAULTS = {
  // Publish-tail defaults the editor's Bake settings block surfaces (the
  // remote config/grading doc's values flow through deepMerge only for keys
  // present here). Mirror of backend/shared/gradingConfig.js render defaults.
  render: {
    renditionHeights: [2160, 1440, 1080],
    renditionPreset: 'fast',
  },
  ceil: {
    vibrance: 24,
    saturation: 12,
    dehaze: 18,
    clarity: 20,
    hslSat: 30,
    wheelSat: 22,
    waterSat: 10,
    waterAmt: 0.7,
    subjectEv: 0.5,
    subjectAmt: 0.7,
  },
  autoMask: {
    subjectLiftCeil: 0.5,
    subjectLiftFloor: 0.12,
    subjectLiftDiv: 36,
    subjectLiftTarget: 52,
    subjectAmount: 0.6,
    subjectBlack: 4,
    subjectSat: 3,
    waterSatBase: 13,
    waterSatSlope: 50,
    waterSatMin: 3,
    waterSatMax: 12,
    waterAmount: 1,
    minConfidence: 0,
  },
  pipeline: {
    stillsConcurrency: 4,
    jobMaxConcurrency: 32,
    stillsParallel: 40,
    stillsRunnerConc: 4,
    drainThreshold: 8,
    drainCap: 12,
    framesPerChunk: 240,
    maxChunks: 32,
    stillsPrepToEfs: false,
  },
  selfAssess: {
    enabled: true,
    satMeanUp: 0.16,
    satP90Up: 0.36,
    tealUp: 0.10,
    castMag: 0.16,
    detailRatioMin: 0.80,
    whiteRBLo: 0.96,
    whiteRBHi: 1.08,
    meanLumaUp: 0.10,
    regionGuard: true,
    regionTol: { tealUp: 0.30, detailRatioMin: 0.78 },
    secondVlm: { enabled: false, url: '', model: '', keyEnv: '' },
  },
};

let _cfg = GRADING_DEFAULTS;
const listeners = new Set();

function deepMerge(base, remote) {
  if (!remote || typeof remote !== 'object') return base;
  const out = {};
  for (const k of Object.keys(base)) {
    const bv = base[k];
    const rv = remote[k];
    out[k] = bv && typeof bv === 'object' && !Array.isArray(bv) ? deepMerge(bv, rv) : (rv == null ? bv : rv);
  }
  return out;
}

export function gradingConfig() { return _cfg; }

export function setGradingConfig(remote) {
  _cfg = deepMerge(GRADING_DEFAULTS, remote);
  listeners.forEach((fn) => { try { fn(_cfg); } catch { /* ignore */ } });
  return _cfg;
}

export function subscribeGradingConfig(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
